import { render, staticRenderFns } from "./form-action-button.vue?vue&type=template&id=2f6fdc96&scoped=true&"
import script from "./form-action-button.vue?vue&type=script&lang=js&"
export * from "./form-action-button.vue?vue&type=script&lang=js&"
import style0 from "./form-action-button.vue?vue&type=style&index=0&id=2f6fdc96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6fdc96",
  null
  
)

export default component.exports